import React from "react";
import Navigation from "../components/Navbar";
import "../styles/locations.css";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

function Locations() {
  return (
    <>
        <Seo path="/locations" />
      <Navigation />

      <section className="locations-section">
        <h1 className="locations-title">Our Global Locations</h1>

        <div className="locations-grid">
          <div className="location-card">
            <h3>Odisha, India</h3>
            <p>
              Arya Gali, Kantabanji <br />
              Bolangir – 767039 <br />
              Odisha, India
            </p>
          </div>

          <div className="location-card">
            <h3>Raipur, India</h3>
            <p>
              7th Floor, Currency Tower <br />
              VIP Road, Telibandha <br />
              Chhattisgarh – 492001
            </p>
          </div>

          <div className="location-card">
            <h3>Michigan, USA</h3>
            <p>
              2222 W. Grand River Ave, Ste A <br />
              Okemos, MI – 48864 <br />
              United States
            </p>
          </div>

          <div className="location-card">
            <h3>Ontario, Canada</h3>
            <p>
              10 Lagerfeld Drive <br />
              Brampton, Ontario <br />
              Canada
            </p>
          </div>

          <div className="location-card">
            <h3>Dubai, UAE</h3>
            <p>
              6th Floor, Al Meydan Road <br />
              Nad Al Sheba 1 <br />
              Dubai, UAE
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Locations;
